import { ArrowButton } from "../General/ArrowButton/ArrowButton";

interface Props {
    currentOrderType: 'desc' | 'asc';
    changeOrderType: (newType: 'desc' | 'asc') => void;
}

/**
 * Интерфейс сортировки для списков
 * @returns 
 */
export const SortInterface: React.FC<Props> = ({ currentOrderType, changeOrderType }) => {
    return (
        <div className="flex flex-col ml-2">
            <button className="hover:text-orange-500 focus:outline-none p-0 leading-none"
                onClick={() => currentOrderType !== 'desc' && changeOrderType('desc')}>
                <ArrowButton state="up" />
            </button>
            <button className="hover:text-orange-500 focus:outline-none p-0 leading-none"
                onClick={() => currentOrderType !== 'asc' && changeOrderType('asc')}>
                <ArrowButton state="down" />
            </button>
        </div>
    );
};